/** What a keydown means for an open context menu with `count` enabled rows. */
export type ContextMenuKeyAction =
  | { kind: 'step'; delta: 1 | -1 }
  | { kind: 'jump'; index: number }
  | { kind: 'activate' }
  | { kind: 'close' }

/**
 * ArrowDown/ArrowUp step the highlight (wrapping), Home/End jump to the first/last row,
 * Enter/Space activate the highlighted row, Escape closes. Any other key is ignored (`null`).
 */
export function resolveContextMenuKeyAction(
  key: string,
  count: number
): ContextMenuKeyAction | null {
  switch (key) {
    case 'ArrowDown':
      return { kind: 'step', delta: 1 }
    case 'ArrowUp':
      return { kind: 'step', delta: -1 }
    case 'Home':
      return { kind: 'jump', index: 0 }
    case 'End':
      return { kind: 'jump', index: count - 1 }
    case 'Enter':
    case ' ':
      return { kind: 'activate' }
    case 'Escape':
      return { kind: 'close' }
    default:
      return null
  }
}
